import { Box, Flex } from '@chakra-ui/react';

import FilterDropdown from '@features/marketplace/navigation/FilterDropdown';
import SortByControls from '@features/marketplace/navigation/SortByControls';
import ToggleFilters from '@features/marketplace/navigation/ToggleFilters';

const FilterControls = () => {
  return (
    <Flex flexDirection="row" gap={2}>
      <Box hideBelow="xl">
        <ToggleFilters />
      </Box>
      <Box hideFrom="xl">
        <FilterDropdown />
      </Box>
      <SortByControls />
    </Flex>
  );
};

export default FilterControls;
